import {Component} from '@angular/core';

@Component({
    selector: 'qa-password-reset-done',
    templateUrl: './password-reset-done.component.html',
    styleUrls: ['./password-reset-done.component.scss'],
    standalone: false
})
export class PasswordResetDoneComponent {

  constructor() { }

}
